import {RightDropdown} from './Item';
import './MapRightSidebar.scss';
export default function MapRightSidebar({menu, setMenu, children}) {
  const menu_list = [
    {label: 'Keluasan Ladang', value: 'keluasan_ladang'},
    {label: 'Data Hasil', value: 'data_hasil'},
    {label: 'Untung & Rugi', value: 'untung_&_rugi'},
    {label: 'Analisis Tanah & Daun', value: 'analisis_tanah_&_daun'},
  ];

  return (
    <div className='mrs_ctr'>
      <RightDropdown
        menu_list={menu_list}
        selectedMenu={menu}
        onClick={(item) => {
          setMenu((prev) => ({...prev, menu: item}));
        }}
      />
      {children}
    </div>
  );
}
